<template>
    <div class="complianceTips">{{ text || $t('complianceTips') }}</div>
</template>

<script>
export default {
    name: 'compliance-tips',
    props: {
        text: {
            type: String,
        },
    },
}
</script>

<style scoped lang="less">
.complianceTips {
    color: #bfbfbf;
    font-size: 12px;
    text-align: center;
    transform: scale(0.92);
}
</style>
